export const MaxUint256 = 115792089237316195423570985008687907853269984665640564039457584007913129639935;
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const MAX_ALLOWANCE = '11579208923731619542357098500868790785326998466564056403945758400791';
